var _MobileMenu, _X;
import * as React from 'react';
import { usePrevious } from '@ovpn-ui/utils';
import { useLocation } from 'react-router-dom';
import { MobileMenu, X } from '@ovpn-ui/icons';
import Sidebar from '../Sidebar';
import { MenuToggle, MobileHeader, MobileSidebarHeader, MobileLogo } from '../Navigation.styles';
import { useMobileSidebar } from '../../hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function MobileNavigation({
  links,
  MobileFooterComponent,
  logo,
  children,
  ...rest
}) {
  const {
    pathname
  } = useLocation();
  const prevPath = usePrevious(pathname);
  const [open, toggleSidebar] = useMobileSidebar();
  React.useEffect(() => {
    const handleNavigate = () => {
      if (open) {
        toggleSidebar();
      }
    };
    if (prevPath !== pathname) {
      handleNavigate();
    }
  }, [prevPath, pathname, open, toggleSidebar]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(MobileHeader, {
      children: [/*#__PURE__*/_jsx(MobileLogo, {
        children: logo
      }), /*#__PURE__*/_jsx(MenuToggle, {
        onClick: toggleSidebar,
        children: _MobileMenu || (_MobileMenu = /*#__PURE__*/_jsx(MobileMenu, {}))
      })]
    }), /*#__PURE__*/_jsx(Sidebar, {
      logo: logo,
      logoCollapsed: undefined,
      mobile: true,
      open: open,
      links: links,
      ...rest,
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs(MobileSidebarHeader, {
          children: [logo, /*#__PURE__*/_jsx(MenuToggle, {
            ariaLabel: "Close",
            onClick: toggleSidebar,
            children: _X || (_X = /*#__PURE__*/_jsx(X, {}))
          })]
        }), MobileFooterComponent && /*#__PURE__*/_jsx(MobileFooterComponent, {}), children]
      })
    })]
  });
}